export const SITE = {
  name: 'Level Up Glass Supply',
  legalName: 'Level Up Glass Supply Pty Ltd',
  abn: 'ABN 79 691 264 230',
  phone: '0431 274 827',
  phoneHref: 'tel:+61431274827',
  email: 'levelupglasssupply@gmail.com',
  address: '1/45 Ravenhall Way, Ravenhall VIC 3023',
  hours: 'Mon–Fri 7:30am–4:00pm',
  mapsUrl: 'https://maps.google.com/?q=1/45+Ravenhall+Way+Ravenhall+VIC+3023',
}

export const CATEGORIES = [
  {
    slug: 'shower-screens',
    name: 'Shower Screens',
    blurb: '10mm frameless & 6mm semi-frameless packages — corner, inline, sliding and over-bath.',
    image: '/images/portfolio/level-up-frameless-corner-shower-screen-marble-melbourne-02.webp',
  },
  {
    slug: 'hardware',
    name: 'Hardware',
    blurb: 'Hinges, brackets, knobs, channels and seals in 6 premium finishes.',
    image: '/images/products/shower-screen-fixed-panel-brushed-nickel-01.jpg',
  },
  {
    // renamed 2026-08-26; the slug stays `glass-panels` so existing links keep working
    slug: 'glass-panels',
    name: '10mm Frameless Glass Panels',
    blurb: '10mm toughened glass panels in stocked sizes, ready to ship.',
    image: '/images/products/shower-screen-fixed-panel-04.jpg',
  },
  {
    slug: 'tools-accessories',
    name: 'Tools & Accessories',
    blurb: 'Silicone, spacers, seals and drill bits for a clean install.',
    image: '/images/products/shower-screen-fixed-panel-02.jpg',
  },
  {
    slug: 'wardrobe-doors',
    name: 'Wardrobe Doors',
    blurb: 'Framed, semi-framed and frameless sliding wardrobe doors, made to measure.',
    image: '',
  },
]

export const CATEGORY_BY_SLUG = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c]))
export const slugForCategory = (name) =>
  CATEGORIES.find((c) => c.name === name)?.slug ??
  name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')

// A product lives in its main category plus any extras in `categories`.
// The main one stays first — it's what breadcrumbs and product cards show.
export function categoriesOf(product) {
  let extra = []
  try { extra = JSON.parse(product.categories || '[]') || [] } catch { /* ignore malformed */ }
  return [...new Set([product.category, ...extra].filter(Boolean))]
}

export const isInCategory = (product, slug) =>
  categoriesOf(product).some((name) => slugForCategory(name) === slug)

// Hardware and tools are shot as a single part on a white background: cropping one to
// fill a tall card magnifies it and cuts the ends off, so those frames fit the whole
// object instead. Screens, panels and wardrobes are room photos, where a crop is right.
export const STUDIO_PHOTO_CATEGORIES = ['Hardware', 'Tools & Accessories']
export const isStudioPhoto = (product) =>
  categoriesOf(product).some((name) => STUDIO_PHOTO_CATEGORIES.includes(name))

export const DELIVERY_OPTIONS = [
  { id: 'pickup', label: 'Warehouse pickup — Ravenhall VIC', detail: 'Free · usually ready in 1–2 business days', price: () => 0 },
  { id: 'delivery', label: 'Local delivery — within 50 km of Ravenhall (VIC only)', detail: '1–3 business days after dispatch · we\'ll confirm your address is in range', price: (s) => Number(s.shipping_delivery ?? 79) },
]

export const GST_RATE = 0.1
